<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Input Data Indikator</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/inputdata">Input Data Indikator</Link>
                </li>
                <li v-if="parent && parent.label" class="breadcrumb-item active">
                  <Link :href="'/admin/inputdata/' + parent.parent_id" v-text="parent.label"></Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Input/Entri Indikator Satu Data</h4>
                  <p class="card-title-desc mb-0">Pengisian volume terhadap data element/indikator yang telah dibuat sebelumnya.</p>
                </div>
              </div>

              <hr />
              
              <div class="d-flex justify-content-between">
                <div class="d-inline-block" style="max-width: 28em; width: 100%">
                  <div class="row g-3 mb-3">
                    <div class="col-md">
                      <div class="form-floating">
                        <select @change="handleRangeFilter" class="form-select" id="tahunmulai" v-model="filter.tahun_mulai">
                          <option v-for="tahun in master.tahun_range" :disabled="tahun > filter.tahun_sampai" :value="tahun" v-text="tahun" :key="'tahun-mulai-' + tahun"></option>
                        </select>
                        <label for="tahunmulai">Mulai dari</label>
                      </div>
                    </div>
                    <div class="col-md">
                      <div class="form-floating">
                        <select @change="handleRangeFilter" class="form-select" id="tahunsampai" v-model="filter.tahun_sampai">
                          <option v-for="tahun in master.tahun_range" :disabled="tahun < filter.tahun_mulai" :value="tahun" v-text="tahun" :key="'tahun-sampai-' + tahun"></option>
                        </select>
                        <label for="tahunsampai">Sampai dengan</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-inline-block">
                  <div class="d-flex gap-2">
                    <label class="btn btn-outline-primary mb-0" v-if="parent" for="file-upload">
                      <Icon :icon="['fa', 'download']" /> Import
                    </label>
                    <input class="d-none" type="file" id="file-upload" @input="inputImport" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                    <a class="btn btn-outline-primary" v-if="parent" :href="`/admin/inputdata/${parent.id}/export`" target="_blank" rel="noopener noreferrer">
                      <Icon :icon="['fa', 'upload']" /> Export
                    </a>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th rowspan="2" class="text-center">#</th>
                      <th rowspan="2">Element Data / Indikator</th>
                      <th rowspan="2">Formula</th>
                      <th :colspan="filter.tahun_range.length" class="text-center">Tahun</th>
                      <th rowspan="2">Satuan</th>
                      <th rowspan="2">Perubahan Terakhir</th>
                      <th rowspan="2" class="text-center">Aksi</th>
                    </tr>
                    <tr>
                      <th v-for="tahun in filter.tahun_range" class="text-center" :key="'head-tahun-mulai-' + tahun" v-text="tahun"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in elementsdata" :key="index">
                      <td scope="row" class="text-center">{{ index + 1 }}</td>
                      <td scope="row">
                        <Link v-if="row.child_count" :href="'/admin/inputdata/' + row.id" v-text="row.label"></Link>
                        <span v-else v-text="row.label"></span>
                        <span class="badge rounded-pill bg-info ms-2" v-if="row.child_count">{{ row.child_count }} Subdata</span>
                      </td>
                      <td scope="row" class="text-center"></td>
                      <td scope="row" v-for="tahun in filter.tahun_range" :key="'body-tahun-mulai-' + tahun" class="text-center" @dblclick="input(row, tahun)" style="position: relative">
                        <input v-if="edit.at == `${row.id}/${tahun}`" v-model="edit.value" type="text" class="form-control entry-data" autofocus @blur="action(row)" />
                        <span v-else v-text="row.inputdata[tahun]"></span>
                      </td>
                      <td scope="row">{{ row.satuan || '-' }}</td>
                      <td scope="row">{{ row.inputdata_last ? new Date(row.inputdata_last.updated_at).toLocaleString() : '-' }}</td>
                      <td scope="row" class="text-center">
                        <Link :href="'/admin/inputdata/' + row.id" class="p-0 btn btn-sm btn-link">Buka</Link> |
                        <a class="p-0 btn btn-sm btn-link" @click="review(row)">Chart</a>
                      </td>
                    </tr>
                    <tr v-if="elementsdata.length == 0">
                      <td scope="row" :colspan="6 + filter.tahun_range.length" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p class="mt-3 mb-2 text-muted"><i>* Doubel klik pada kolom tahun dan indikator untuk dapat mengisi data element!</i></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
    <modal :show="chart.show" @close="chart.show = false" :title="'Preview Indikator'" size="xl" backdrop="static">
      <template #default>
        <div class="mb-3">
          <select name="tipe" id="tipe" v-model="chart.type" class="form-select d-inline-block">
            <option value="bar">Bar Chart</option>
            <option value="pie">Pie Chart</option>
          </select>
        </div>
        <div class="mb-3 px-5">
          <canvas ref="chart"></canvas>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)
const iColors = ['#109618', '#FF9900', '#DC3912', '#990099', '#3B3EAC', '#22AA99', '#22AA99', '#316395', '#DD4477', '#66AA00', '#808000', '#B82E2E', '#0099C6', '#994499', '#E67300']

export default {
  layout: Layout,
  components: { Modal },
  props: {
    settingtahun: Object,
    elementsdata: Array,
    parent: Object,
  },
  data() {
    return {
      edit: {
        at: '',
        value: '',
      },
      chart_container: false,
      chart: {
        show: false,
        row: null,
        type: 'bar',
      },
      master: {
        tahun_mulai: 0,
        tahun_sampai: 0,
        tahun_range: [],
      },
      filter: {
        tahun_mulai: 0,
        tahun_sampai: 0,
        tahun_range: [],
      },
    }
  },
  methods: {
    handleRangeFilter() {
      this.filter.tahun_range = []
      for (let i = this.filter.tahun_mulai; i <= this.filter.tahun_sampai; i++) {
        this.filter.tahun_range.push(i)
      }
    },
    action({ inputdata }) {
      const { at, value } = this.edit
      const [id, tahun] = at.split('/')
      inputdata[tahun] = value
      this.$inertia.post('/admin/inputdata', {
        id,
        tahun,
        value,
      })
    },
    input(row, tahun) {
      this.edit.at = `${row.id}/${tahun}`
      this.edit.value = row.inputdata[tahun]
    },
    review(row) {
      this.chart.row = row
      this.chart.show = true
    },
    appendChart() {
      const { show, type, row } = this.chart
      if (this.chart_container) this.chart_container.destroy()
      if (show) {
        const datasets = []
        datasets.push({
          label: row.label,
          backgroundColor: type == 'pie' ? this.master.tahun_range.map((r, i) => iColors[i]) : '#0af',
          data: this.master.tahun_range.map((r) => (row.inputdata[r] ? row.inputdata[r] : 0)),
        })
        setTimeout(() => {
          this.chart_container = new Chart(this.$refs.chart, {
            type: type,
            data: {
              labels: this.master.tahun_range,
              datasets,
            },
            options: {},
          })
        }, 300) // tunggu sampai animasi modal kelar
      }
    },
    inputImport(event) {
      if(!event.target.files[0]) return
      this.$inertia.post(`/admin/inputdata/${this.parent.id}/import`, {
        berkas: event.target.files[0]
      });
    }
  },
  watch: {
    chart: {
      handler() {
        this.appendChart()
      },
      deep: true,
    },
  },
  mounted() {
    this.master.tahun_mulai = this.settingtahun.tahunmulai;
    this.master.tahun_sampai = this.settingtahun.tahunsampai;
    this.filter.tahun_mulai = this.settingtahun.tahunmulai;
    this.filter.tahun_sampai = this.settingtahun.tahunsampai;

    this.master.tahun_range = []
    for (let i = this.master.tahun_mulai; i <= this.master.tahun_sampai; i++) {
      this.master.tahun_range.push(i)
      this.filter.tahun_range.push(i)
    }

    Inertia.on('start', (event) => {
      this.edit.at = ''
    })
  },
}
</script>


<style>
.entry-data {
  width: unset;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  border-radius: 0;
  overflow: unset;
}
</style>